/** @jsxImportSource @emotion/react */
import InfoTip, {P} from './info-tip';

const ScheduleItemsInfo = function () {
  return (
    <InfoTip
      info={
        <section css={{width: 300}}>
          <h3>員工可排項目</h3>
          <P>
            開放排班人員於 Apollo XE 中，在當月份安排次月的班表。<br/>例如公司設定開放 5/21~5/25 區間，可排六月班表。
          </P>
          <P>
            若未勾選班次/月休/調整班次時間，即為不開放讓員工排班。
          </P>
          <P>班次/月休: 排班員工可以排定被套用的班次及月休天數</P>
          <P>調整班次時間: 排班員工可以自行調整班次中的上下班時間</P>
        </section>
      }
    />
  );
};

export default ScheduleItemsInfo;
